var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from "react";
export const AsyncButton = (_a) => {
    var { onClick, callback, className = null, question = null, loader = true, waitForFinish = false, type, children } = _a, inputProps = __rest(_a, ["onClick", "callback", "className", "question", "loader", "waitForFinish", "type", "children"]);
    const [isLoading, setLoading] = useState(false);
    if (isLoading && loader) {
        return React.createElement("button", { className: className + " loading" });
    }
    return (React.createElement("button", Object.assign({}, inputProps, { type: type, className: className, disabled: isLoading, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
            let confirmed = true;
            if (question) {
                confirmed = window.confirm(question);
            }
            if (confirmed) {
                if (loader) {
                    setLoading(true);
                }
                if (onClick) {
                    yield onClick();
                }
                if (callback) {
                    callback();
                }
                if (loader && waitForFinish) {
                    setLoading(false);
                }
            }
        }) }), children));
};
